<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :class="tableClass"
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top v-if="!isMinimal">
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import hipotekaTabs from '../../../mixins/hipotekaTabs'

export default {
  name: 'IstorijaDuomenys',
  props: {
    duomenys: String,
    objId: Number,
  },
  mixins: [hipotekaTabs],
  data() {
    return {
      loading: true,
      search: null,
      istorija: [],
      obj_tipas: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas']),
    headers() {
      return [
        {
          text: 'Naudotojas',
          align: 'start',
          value: 'naudotojas',
        },
        {
          text: 'Data',
          align: 'start',
          value: 'data',
        },
        {
          text: 'Kortelė',
          align: 'start',
          value: 'tabTitle',
        },
        {
          text: 'Laukas',
          align: 'start',
          value: 'laukas',
        },
        {
          text: 'Buvusi reikšmė',
          align: 'start',
          value: 'reiksme_buvusi',
        },
        {
          text: 'Nauja reikšmė',
          align: 'start',
          value: 'reiksme_nauja',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    tabItems() {
      return Object.fromEntries(
        Object.entries(this.hipotekaTabs).map(([key, item]) => {
          return [item.errorTab, item]
        })
      )
    },
    itemsList() {
      return this.istorija.map(item => {
        item.tabTitle = this.tabItems[item.tabas]
          ? this.tabItems[item.tabas].title
          : item.tabas
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isMinimal() {
      return this.objId > 0
    },
    comObjektasID() {
      return this.objId ?? this.objektasID
    },
    tabHipotekaTipas() {
      return this.isMinimal ? this.obj_tipas : this.hipotekaTipas
    },
    tableClass() {
      return this.isMinimal ? 'miniTable' : ''
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$axios
        .get(
          `objektas/${this.comObjektasID}/duomenustorija${
            !this.isMinimal ? '/' + this.duomenys : ''
          }`
        )
        .then(res => {
          this.istorija = res.data.objektas
          this.obj_tipas = res.data.obj_tipas
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
